export default __webpack_public_path__ + "static/media/DSC_9074-thumb.0e0eaf96.jpg";